import { AbstractControl, ValidationErrors } from '@angular/forms';

export function ValidateDateRange(campo1: string, campo2: string) {
  return (formControl: AbstractControl): ValidationErrors | null => {
    const start = formControl.get(campo1);
    const end = formControl.get(campo2);

    return start?.value !== null && end?.value !== null && start?.value <= end?.value ? null : { isValid: true };
  };
}
